export const ZOOM_TO_DESIGN_BUTTON_PORTAL_ID =
  "zoom-to-design-button-portal-id";

export const ZoomToDesignButtonPortal: React.FC = () => {
  return <div id={ZOOM_TO_DESIGN_BUTTON_PORTAL_ID} />;
};
